import { IUnit } from "../interfaces/unit";

export class LengthUnits {
  static inch: IUnit = { id: 0, display: "in" };
  static mm: IUnit = { id: 1, display: "mm" };

  static getById(id: number) {
    let values = Object.values(LengthUnits);
    return values[id];
  }

  static convertInchesToMm(inches: number): number {
    return inches * 25.4;
  }

  static convertMmToInches(mm: number): number {
    return mm / 25.4;
  }
}
